import { Warning } from "@phosphor-icons/react";

export const DisclaimerNote = ({ text, testId = "disclaimer-note" }) => (
  <div
    className="flex gap-3 border border-slate-200 bg-slate-100/70 p-4 text-xs leading-relaxed text-slate-600"
    data-testid={testId}
  >
    <Warning size={18} className="mt-0.5 shrink-0 text-navy-800" />
    <p>{text}</p>
  </div>
);
